/**
 * Hook to get current user from Keycloak
 */

import { useContext, useState, useEffect } from 'react';
import KeycloakContext from '../KeycloakProvider';

export const useCurrentUser = () => {
  const { keycloak } = useContext(KeycloakContext);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (keycloak) {
      try {
        // Get user info from tokenParsed first
        if (keycloak.tokenParsed) {
          setCurrentUser({
            id: keycloak.tokenParsed.sub || keycloak.tokenParsed.id,
            username: keycloak.tokenParsed.preferred_username || keycloak.tokenParsed.username,
            email: keycloak.tokenParsed.email,
            firstName: keycloak.tokenParsed.given_name,
            lastName: keycloak.tokenParsed.family_name,
            groups: keycloak.tokenParsed.realm_access?.roles || keycloak.tokenParsed.groups || [],
            realm_access: keycloak.tokenParsed.realm_access || {},
          });
        }
      } catch (error) {
        console.error('Error getting current user:', error);
      }
      setLoading(false);
    }
  }, [keycloak]);

  return { currentUser, loading };
};

export default useCurrentUser;
